import { render, staticRenderFns } from "./give-red.vue?vue&type=template&id=e7164478&scoped=true"
import script from "./give-red.vue?vue&type=script&lang=js"
export * from "./give-red.vue?vue&type=script&lang=js"
import style0 from "./give-red.vue?vue&type=style&index=0&id=e7164478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7164478",
  null
  
)

export default component.exports